import { render, staticRenderFns } from "./CustomerDevices.vue?vue&type=template&id=54db23ee&"
import script from "./CustomerDevices.vue?vue&type=script&lang=js&"
export * from "./CustomerDevices.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDevices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports